module.exports = __webpack_public_path__ + "static/img/1.990d75de.png";